define('webshopQuotationsDetailView',[
  'module',
  'marionette',
  'underscore',
  'entities/webshop/quotations',
  'template!webshopQuotationsDetailView'
], function (
  Module,
  Marionette,
  _,
  QuotationsApi,
  Tpl
) {
  'use strict';

  // Right pane: the figures stored with the quotation, plus the webshop document itself
  // (rebuilt by the webshop from the stored configuration, as the customer sees it).
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-quotations-detail-view',

    initialize: function (options) {
      this.quotation = null;
      this.loading = true;
      this.error = '';

      QuotationsApi.get(options.quotationId).done(_.bind(function (quotation) {
        this.quotation = quotation;
      }, this)).fail(_.bind(function (message) {
        this.error = message;
      }, this)).always(_.bind(function () {
        this.loading = false;
        if (!this.isDestroyed)
          this.render();
      }, this));
    },

    serializeData: function () {
      var q = this.quotation;

      if (!q)
        return {q: null, loading: this.loading, error: this.error};

      var price = function (value) {
        return QuotationsApi.formatPrice(value, q.currency);
      };

      return {
        q: _.extend({}, q, {
          date: QuotationsApi.formatDate(q.createdAt),
          site: _.compact([q.domain ? '.' + q.domain : '', q.locale]).join(' / '),
          unitPrice: price(q.unitPrice),
          totalPrice: price(q.totalPrice),
          deliveryCost: price(q.deliveryCost),
          scales: _.map(q.scales || [], function (s) {
            return {
              quantity: s.quantity,
              unitPrice: price(s.unitPrice),
              selected: s.quantity === q.quantity
            };
          })
        })
      };
    }
  });
});

